import {
  Box,
  Step,
  StepIcon,
  StepIndicator,
  StepNumber,
  Stepper,
  StepSeparator,
  StepStatus,
  StepTitle,
} from '@chakra-ui/react';
import { useTheme } from '../../../contexts/ThemeProvider';

interface TelemedicineStepperProps {
  steps: string[];
  currentStep: number;
}

/**
 * Indicador de progresso puramente visual — sem onClick nos steps. O avanço
 * é sempre automático, disparado pelas ações concluídas em cada etapa da página.
 */
export function TelemedicineStepper({ steps, currentStep }: TelemedicineStepperProps) {
  const { colors } = useTheme();

  return (
    <Box
      width={'100%'}
      padding={{ base: '10px', md: '12px' }}
      borderRadius={'16px'}
      backgroundColor={'#FFFFFF'}
      border={'1px solid #E2E8F0'}
      overflow={'hidden'}
      sx={{
        '--stepper-accent-color': colors.primaryColor,
      }}
    >
      <Stepper index={currentStep} size={'sm'} colorScheme={'green'} gap={{ base: '4px', md: '16px' }}>
        {steps.map((title) => (
          <Step key={title} style={{ cursor: 'default' }}>
            <StepIndicator
              sx={{
                '&[data-status="complete"]': { background: colors.primaryColor, borderColor: colors.primaryColor },
                '&[data-status="active"]': { borderColor: colors.primaryColor },
              }}
            >
              <StepStatus complete={<StepIcon />} incomplete={<StepNumber />} active={<StepNumber />} />
            </StepIndicator>

            <Box display={{ base: 'none', md: 'block' }} marginLeft={2}>
              <StepTitle style={{ fontSize: '12px' }}>{title}</StepTitle>
            </Box>

            <StepSeparator />
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}
